
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("cgxeN"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("cgxeN", function(module, exports) {

let $8ee0c2f9db37edb2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8ee0c2f9db37edb2$var$load("h3ABO"),
    $8ee0c2f9db37edb2$var$load("fSobj"),
    $8ee0c2f9db37edb2$var$load("74u2y"),
    $8ee0c2f9db37edb2$var$load("2YffH"),
    $8ee0c2f9db37edb2$var$load("1aTst"),
    $8ee0c2f9db37edb2$var$load("6mHrv"),
    $8ee0c2f9db37edb2$var$load("awWN9"),
    $8ee0c2f9db37edb2$var$load("9CYct"),
    $8ee0c2f9db37edb2$var$load("bLsON"),
    $8ee0c2f9db37edb2$var$load("cPXmn"),
    $8ee0c2f9db37edb2$var$load("hZtKG"),
    $8ee0c2f9db37edb2$var$load("iNmaF"),
    $8ee0c2f9db37edb2$var$load("lVO3w"),
    $8ee0c2f9db37edb2$var$load("hyzoX"),
    $8ee0c2f9db37edb2$var$load("h9Ed7"),
    $8ee0c2f9db37edb2$var$load("eBRUf"),
    $8ee0c2f9db37edb2$var$load("b2zxR"),
    $8ee0c2f9db37edb2$var$load("tKhaz"),
    $8ee0c2f9db37edb2$var$load("GYf7c"),
    $8ee0c2f9db37edb2$var$load("ceKWn"),
    $8ee0c2f9db37edb2$var$load("cD6Zr"),
    $8ee0c2f9db37edb2$var$load("dtASV"),
    $8ee0c2f9db37edb2$var$load("kWohI"),
    $8ee0c2f9db37edb2$var$load("8YSo7"),
    $8ee0c2f9db37edb2$var$load("g7ggm"),
    $8ee0c2f9db37edb2$var$load("Wowvf"),
    $8ee0c2f9db37edb2$var$load("9S9Mz"),
    $8ee0c2f9db37edb2$var$load("kiGNy"),
    $8ee0c2f9db37edb2$var$load("7do1E"),
    $8ee0c2f9db37edb2$var$load("77dkW"),
    $8ee0c2f9db37edb2$var$load("1MlIV"),
    $8ee0c2f9db37edb2$var$load("g9CVe"),
    $8ee0c2f9db37edb2$var$load("7oiUM"),
    $8ee0c2f9db37edb2$var$load("8t3po"),
    $8ee0c2f9db37edb2$var$load("855o0"),
    $8ee0c2f9db37edb2$var$load("8MfZE"),
    $8ee0c2f9db37edb2$var$load("hv4mn"),
    $8ee0c2f9db37edb2$var$load("dek7I"),
    $8ee0c2f9db37edb2$var$load("dYtBN"),
    $8ee0c2f9db37edb2$var$load("6wr18"),
    $8ee0c2f9db37edb2$var$load("kjZZD"),
    $8ee0c2f9db37edb2$var$load("iHx5x"),
    $8ee0c2f9db37edb2$var$load("hi1rZ"),
    $8ee0c2f9db37edb2$var$load("jjLHK"),
    $8ee0c2f9db37edb2$var$load("cxoS1"),
    $8ee0c2f9db37edb2$var$load("37ldp"),
    $8ee0c2f9db37edb2$var$load("ffEVr"),
    $8ee0c2f9db37edb2$var$load("dRpV3"),
    $8ee0c2f9db37edb2$var$load("dTsOE"),
    $8ee0c2f9db37edb2$var$load("hhss7"),
    $8ee0c2f9db37edb2$var$load("jwTn5"),
    $8ee0c2f9db37edb2$var$load("aYdgM"),
    $8ee0c2f9db37edb2$var$load("6u1hm"),
    $8ee0c2f9db37edb2$var$load("klApM"),
    $8ee0c2f9db37edb2$var$load("eQgf0"),
    $8ee0c2f9db37edb2$var$load("8fMw3"),
    $8ee0c2f9db37edb2$var$load("hogcU"),
    $8ee0c2f9db37edb2$var$load("74vOE"),
    $8ee0c2f9db37edb2$var$load("7EorR"),
    $8ee0c2f9db37edb2$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.66547551.js.map
